import usePaging from "../../../hooks/usePaging";
import { useGetTagsQuery } from "../tagsSlice";
import { useLocation } from "react-router-dom";
import useHasAccess from "../../../hooks/useHasAccess";

const useTags = () => {
  const { activePage } = usePaging({});
  const location = useLocation();
  const hasAccess = useHasAccess({ apiCall: "tags.GET" });
  const tags = useGetTagsQuery(
    {
      page: location?.pathname?.includes("tags") ? activePage : 1,
    },
    {
      skip: !hasAccess,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  return {
    ...tags,
    data: tags?.data?.response,
    pagination: tags?.data?.pagination,
    hasAccess,
  };
};

export default useTags;
